import React, { useState, useEffect } from 'react';

import logo from './logo.svg';
import './App.css';

import Root from './components/root.js';


function App() {
	return (
		<div className="App">
			<Root />
		</div>
	);
}


export default App;
